export default __webpack_public_path__ + "static/media/chbx.cb6bcd25.svg";